import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { List, ListItem } from "@mui/material";

import { Box, Divider, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { DownArrowIconBlueLIne } from "../../assets/Icon/ArrowIcon";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import CustomButton from "../../components/common-components/CustomButton";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Header,
  ModalWrapper,
} from "../../components/style/modalStyleLarge";
import { useAppDispatch } from "../../stores/store";
import { Description, InstructionWrapper, Title } from "../style/modalStyle";

interface InstructionSet {
  title?: string;
  heading?: string;
  instructions?: string[];
}

interface ModalPropType {
  open: boolean;
  handleClose?: () => void;
  id?: number | null;
  onSuccess?: () => void;
  data?: InstructionSet[];
  title?: string;
}

export default function PassportInstructionModal({
  open,
  handleClose,
  title,
  data,
  id,
  onSuccess,
}: ModalPropType) {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-modal-title"
    >
      <ModalWrapper
        sx={{
          // width: isMobile ? "90%" : "45%",
          maxWidth: "498px",
          minHeight: "350px",
          maxHeight: "602px",
          margin: "auto",
          overflow: "hidden",

          p: isMobile ? 2 : 3,
        }}
      >
        <CloseButtonWrapper>
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>
        <Header>
       
          <Stack direction="row" alignItems="center" spacing={0}>
            <DownArrowIconBlueLIne />
            <Typography
              sx={{
                fontSize: "30px",
                fontWeight: 700,
                whiteSpace: "nowrap",
              }}
            >
              {title}
            </Typography>
          </Stack>
        </Header>
        <Divider />

        <Content sx={{ height: "220px", overflowY: "auto" }}>
          {data?.map((item, index) => (
            <InstructionWrapper key={index}>
              <Stack spacing={1}>
                <Title>{item.title}</Title>
                {item.heading && (
                  <Typography
                    sx={{ fontSize: "18px", fontWeight: 600, paddingY: 2 }}
                  >
                    {item.heading}
                  </Typography>
                )}
                {(item.instructions ?? []).length > 0 && (
                  <List sx={{ listStyleType: "disc", width: "100%" }}>
                    {(item.instructions ?? []).map((instruction, idx) => (
                      <Description key={idx}>
                        {" "}
                        <Box>{`${idx + 1}. `}</Box>
                        <Box>{instruction}</Box>
                      </Description>

                    
                    ))}
                  </List>
                )}
              </Stack>
            </InstructionWrapper>
          ))}
        </Content>

        <ButtonWrapper
          sx={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "15px",
            justifyContent: isMobile ? "center" : "space-between",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "10px" : "2px",
          }}
        >
          <CustomButton
            btnTitle="Ok"
            handleClick={handleClose}
            minwidth={isMobile ? "100%" : "45%"}
            borderColor={loading ? "transparent" : "#2977CC"}
            sx={{ fontSize: "18px" }}
          />
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
}
